import { useMemo } from "react";

export const useSplitContentSections = (contentWithImageData) => {
  const { fullNavySections, splitSections } = useMemo(() => {
    if (!Array.isArray(contentWithImageData)) {
      return {
        fullNavySections: [],
        splitSections: [],
      };
    }

    return contentWithImageData.reduce(
      (acc, item) => {
        if (item.bgStyle === "full_navy") {
          acc.fullNavySections.push(item);
        }

        if (item.bgStyle === "split_background") {
          acc.splitSections.push(item);
        }

        return acc;
      },
      {
        fullNavySections: [],
        splitSections: [],
      }
    );
  }, [contentWithImageData]);

  return {
    fullNavySections,
    splitSections,
  };
};